const narrative = [
  "O cliente abre o cardápio.",
  "Encontra dezenas de opções.",
  "Não consegue imaginar direito o produto.",
  "Compara preços.",
  "E muitas vezes escolhe aquilo que já conhece.",
];

export default function PainSection() {
  return (
    <section id="dor" className="bg-background-50 py-24 md:py-32">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="reveal mx-auto max-w-3xl text-center">
          <span className="mb-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-primary-600">
            <span className="h-px w-6 bg-current" />
            Um problema invisível
            <span className="h-px w-6 bg-current" />
          </span>
          <h2 className="font-heading text-3xl font-bold leading-[1.08] tracking-tight text-foreground-950 md:text-5xl">
            Seu melhor prato pode estar{" "}
            <span className="text-primary-500">sendo ignorado.</span>
          </h2>
        </div>

        <div className="mt-12 md:mt-16">
          <ol className="space-y-1">
            {narrative.map((line, i) => (
              <li
                key={line}
                className="reveal flex items-center gap-4 md:gap-6"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <span className="font-heading text-sm font-bold text-primary-500/40 md:text-base">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="menu-serif-body text-xl leading-relaxed text-foreground-700 md:text-3xl">
                  {line}
                </span>
              </li>
            ))}
          </ol>

          <div className="reveal mt-14 border-t border-background-200 pt-10 text-center md:mt-16 md:pt-12">
            <p className="mx-auto max-w-2xl font-heading text-xl font-semibold leading-snug text-foreground-950 md:text-3xl">
              O problema não é apenas o seu produto.
              <br />
              <span className="text-foreground-500">
                É como ele está sendo apresentado.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}